import Config from "../config";

declare global {
    interface Window {
        Chargebee: any;
    }
};

const Chargebee = window.Chargebee;

var cbInstance: any = null;

var getCbInstance = () => {
    if (!cbInstance) {
        cbInstance = Chargebee.init({
            site: Config.CHARGEBEE_SITE
        });
    }
    return cbInstance;
}

export default getCbInstance;